import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getAboutData } from '../../Public/about-data';
import useHandleRedirect from '../../Hooks/useHandleRedirect';

import LandingHeroSection from '../Landing-screen/landing-hero-section';
import ContentSection from '../../Utils/Content/content-section-component';
import WhatWeDoSection from '../../Utils/Sections/section-what-we-do-component';
import WhyChooseUsSection from '../../Utils/Sections/section-why-choose-us-component';
import OurApproachSection from '../../Utils/Sections/section-our-approach-component';
import WholesalePartnerSection from '../../Utils/Sections/section-wholesale-partner-component';

function AboutScreen() {
    const navigate = useHandleRedirect();
    const { language = 'en', dir = 'ltr' } = useSelector((state) => state.systemData || {});
    const aboutData = useMemo(() => getAboutData(language), [language]);

    if (!aboutData) return null;

    const {
        processSection,
        whyChooseUsSection,
        whatWeDoSection,
        ourApproachSection,
        wholesalePartnerSection,
    } = aboutData;

    return (
        <div className="w-full bg-[#f8f7f2] text-primary-950 selection:bg-secondary-500/30 overflow-hidden" dir={dir}>
            <main className="w-full flex flex-col">

                <LandingHeroSection />

                <section className="w-full px-4 md:px-6 py-6 md:py-10">
                    <div className="max-w-[1400px] mx-auto rounded-[2rem] md:rounded-[3rem] bg-white border border-black/5 shadow-[0_25px_80px_rgba(0,0,0,0.06)] overflow-hidden">
                        <WhatWeDoSection sectionData={whatWeDoSection} />
                    </div>
                </section>

                <WhyChooseUsSection sectionData={whyChooseUsSection} />

                <section className="w-full px-4 md:px-6 py-6 md:py-10">
                    <div className="max-w-[1400px] mx-auto rounded-[2rem] md:rounded-[3rem] bg-primary-950 text-white overflow-hidden">
                        <OurApproachSection sectionData={ourApproachSection} />
                    </div>
                </section>

                <ContentSection
                    label={processSection.label}
                    title={processSection.title}
                    subtitle={processSection.subtitle}
                    backgroundImage={processSection.backgroundImage}
                    buttonText={processSection.buttonText}
                    disclaimer={processSection.disclaimer}
                    onButtonClick={() => navigate('/contact')}
                />

                <WholesalePartnerSection sectionData={wholesalePartnerSection} />

            </main>
        </div>
    );
}

export default AboutScreen;